import { msg } from '@lingui/core/macro';
import { BackendErrorCode, getErrorReason } from 'shared/errors';
import type { MessageDescriptor } from 'shared/i18n';

/**
 * Текст отказа генерации матчей; переводится на месте показа.
 *
 * Разбор — общий (`shared/errors`): 403 — по коду, четыре причины кода 8005 — правилами «по тексту»
 * реестра. Здесь только то, что точнее на этом экране, и запасной текст.
 */
export function getGenerateMatchesErrorMessage(error: unknown): MessageDescriptor {
  return (
    getErrorReason(error, { overrides: { [BackendErrorCode.NOT_ALLOWED]: msg`У вас нет прав для генерации матчей` } }) ??
    msg`Ошибка генерации матчей`
  );
}
